import { IFormService } from "../../service/form/FormService";

export default class GetFormVersionsInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formReportingPeriodId: number) {
    return this.formService.getFormVersions(formReportingPeriodId);
  }
}
